import type { SchemaField } from 'core/components/lib/DynamicForm/logic/schema'
import { peachIdRule } from 'core/helpers/peachId'
import { validators } from 'core/hooks/useForm'

// The schema types whitelistedIPs as an array of bare strings, which
// ArrayEditor renders as rows of a field named '0'. JSON is readable.
export const apiKeyFieldOverrides: {
  [fieldPath: string]: SchemaField['component']
} = {
  whitelistedIPs: 'JsonInput',
}

// validationRules replaces every generated rule at its path, so the required
// rule keysRequestSchema produces has to be restated here to survive.
export const apiKeyCreateRules = {
  userId: [validators.required, peachIdRule],
}
